<template>
  <div class="footer">
    <div class="company">
      <p class="nameCompany">Gravi Águas</p>
      <p>R Blumenau, 560 - SL 3 - Centro - Águas de Chapecó, SC - CEP: 89883-000</p>
      <p>(49) 3339-0000 - (49) 98422-1101</p>
    </div>
    <div class="nets">
      <p>Siga-nos</p>
      <i class="fab fa-facebook"></i>
      <i class="fab fa-instagram-square"></i>
      <i class="fab fa-youtube"></i>
      <a href="https://www.lucianoramos.dev/" class="lucianoRamos" target="_blank" rel="noopener noreferrer">Desenvolvido por Luciano Ramos</a>
      <span class="version">Versão 11082024</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style lang="scss" scoped>
.footer {
  height: 120px;
  background-color: #454545;
  color: #b0b0b0;
  padding: 20px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .company {
    line-height: 5px;
    font-size: 14px;
    margin-top: 15px;
    .nameCompany {
      font-size: 18px;
    }
  }
  .nets {
    text-align: center;
    padding-top: 0px;
    p {
      font-size: 16px;
      margin-bottom: 5px;
    }
    i {
      padding: 0px 5px;
      margin-top: -10px;
      &:hover {
        cursor: pointer;
        color: #e7e7e7;
      }
    }
    .lucianoRamos {
      display: block;
      font-size: 12px;
      padding-top: 8px;
      color: #b0b0b0;
       &:hover {
        cursor: pointer;
        color: #e7e7e7;
      }
    }
    .version {
      font-size: 14px;
    }
  }
}

// PARA NÃO SAIR NO FUNDO DA IMPRESSAO ERRO DO CHROME
@media print {
      .footer {
      display: none !important;
    }
  }
</style>
